<template>
  <section class="quote-info">
    <!--    <div class="box">-->
    <!--      <h3>Insured Information</h3>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Title</span>-->
    <!--          <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Last Name</span>-->
    <!--          <span>{{ formData.isrd_lst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>First Name</span>-->
    <!--          <span>{{ formData.isrd_fst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Date of Birth</span>-->
    <!--          <span>{{ formData.isrd_dob_date }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Email</span>-->
    <!--          <span>{{ formData.email }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Mobile Number</span>-->
    <!--          <span>{{ formData.mobile_no }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>HKID Number</span>-->
    <!--          <span>{{ formData.id_no }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Effective date</span>-->
    <!--          <span>{{ formData.pcy_cmnt_dt }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Expiry Date</span>-->
    <!--          <span>{{ formData.pcy_expry_dt }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>From Hong Kong to :</span>-->
    <!--          <span>{{ getAllOptionName22('from_hk_to', formData.from_hk_to_id) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Plan Class</span>-->
    <!--          <span>{{ getAllOptionName22('plan_class', formData.plan_class) }}</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <table
          class="table"
          :class="item.class">
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="sumItem.type!='array' || !sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <td>{{ sumItem.name }}</td>
            <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </td>
            <td
              v-else
              class="compare">
              <span class="text-line color-danger">
                {{ showCompare(sumItem, oldForm[sumItem.field]) }}
              </span>
              <span class="color-success">
                {{ showCompare(sumItem, formData[sumItem.field]) }}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box"
        :class="item.boxClass" >
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <table
          class="table"
          :class="item.class">
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <td>{{ sumItem.name }}</td>
            <td
              v-if="sumItem.type == 'value'&&!sumItem.option"
              v-copy="sumItem.value">
              {{ sumItem.value }}
            </td>
            <td
              v-else-if="sumItem.type == 'value'&&sumItem.option"
              v-copy="getName(sumItem.value)">
              {{ getName(sumItem.value) }}
            </td>
            <td
              v-else-if="sumItem.type == 'file'"
              class="blue pointer"
              @click="openFile(sumItem.value.url)">
              {{ getClientName(sumItem.value) }}
              <!--              {{ sumItem.value.client_name }}-->
            </td>
            <td
              v-else-if="sumItem.type == 'array'"
            >
              <span
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum.name">{{sum.name}}<br></span>
            </td>
            <td
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              <span  v-if="sumItem.type == 'value'">{{ sumItem.value }}</span>
              <span v-else>{{ showCompare(sumItem, formData[sumItem.field]) }}</span>
              <email-tooltip
                v-if="sumItem.field == 'email'"
                :email="formData.email"></email-tooltip>
            </td>
          </tr>
        </table>
      </div>
    </template>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import dayjs from 'dayjs'
import OMath from '@/utils/math'

export default {
  name: 'WorkingQuoteInfo',
  mixins: [MixinOptions,MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    globalOption(){
      return this[`allOptions${this.formData.class_id}`]||{}
    },
    compareData() {
      let {quote_coverage_list={}} = this.formData||{}
      let {benefits} = this.globalOption||{}
      let benefitsList = benefits || []
      let arr =[]
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          return this.formData.benefits.includes(item.id)
        })
      }
      let list = [
        {
          title: '',
          class: 'mg-b-10',
          list:
            [
              {
                name: 'Destination',
                // type:'value',
                field:'destination_id',
                option:22,
                fieldCode: 'from_hk_to'
                // value: this.getAllOptionName22('from_hk_to',this.formData.destination_id)
              },
              {
                name: 'Expected Effective Date',
                field: 'pcy_cmnt_date',
                type:'value',
                value:this.formData.is_eff_dt_delay&&this.isQuote?'ASAP':`${this.formData.pcy_cmnt_date} ${this.formData.is_eff_dt_delay&&!this.isQuote?'(ASAP)':''}`
              },
              {
                name: 'Expected Expiry Date',
                field: 'pcy_expry_date',
                // option:10
              },
              {
                name: 'Optional Benefits',
                field: 'benefits',
                type:'array',
                value:arr
              },
              {
                name: 'Insurer',
                field: 'company_language',
                notShow:!this.showCompany
              },
            ]
        },
        {
          title: 'Policyholder Detail',
          isCompare: true,
          isBold: true,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm'
            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: 'Date of Birth',
              field: 'isrd_dob_date',
            }, {
              name: this.formData.id_type==1?'HKID':'Passport',
              field: 'id_no'
            }, {
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            },{
              name: 'Mobile Number',
              field: 'mobile_no',

            }, {
              name: 'Email',
              field: 'email',

            },
          ],
        },
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
        // {
        //   title: 'Upload Document',
        //   isCompare: false,
        //   isBold: true,
        //   list: [
        //     {
        //       name: 'Policyholder HKID',
        //       field: '',
        //
        //     }
        //   ],
        // },
      ]
      return list
    },
  },
  methods:{
    getClientName(data){
      let {client_name=''} = data||''
      return client_name
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    showCompare(item, field,sunF) {
      var change = field
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 10:
            let {pcy_cmnt_dt=''} = this.formData||{}
            change=pcy_cmnt_dt?dayjs(pcy_cmnt_dt).add(1,'year').format('YYYY-MM-DD'):''
            break
          case 24:
            change = this.getAllOptionName24(item.fieldCode, field)
            break
          case 22:
            change = this.getAllOptionName22(item.fieldCode, field)
            break
          case 26:
            change = this.getAllOptionName26(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      if (item.isSum) {
        change = OMath.formatMoney(field, 2, true) + 'HK$'
      }
      return change
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-info {
  .box {
    margin-bottom: 15px;
  }
  .mg-b-0 {
    margin-bottom: 0!important;
  }

  .title {
    display: block;
    padding: 15px 0;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }

  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
